import {
  ASSET,
  COLLECTION,
  COMPANY,
  CONTACT,
  SHARE,
  STREAM,
  USER,
  USER_GROUP,
  DEAL_ROOM
} from "src/types/clusterFilters";
import { AdvocacyTables, DiscoveryTables, EngagementTables, PerformanceTables, ReportTabs } from "src/types/reports";

export const POPULAR_ASSET_SCHEMA = [
  {
    column: "Asset Name",
    field: "name",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "File Type",
    field: "fileType",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Author",
    field: "author",
    width: 40,
    type: String,
    value: (row) => row[3],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Downloads",
    field: "downloads",
    type: Number,
    value: (row) => Number(row[7]),
  },
];

export const DISCOVERY_POPULAR_ASSET_SCHEMA = [
  {
    column: "Asset Name",
    field: "name",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Author",
    field: "author",
    width: 40,
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[3]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "File Type",
    field: "fileType",
    type: String,
    width: 40,
    value: (row) => row[6],
  },
];

export const TOP_USERS_SCHEMA = [
  {
    column: "User Name",
    field: "userName",
    type: String,
    width: 50,
    value: (row) => row[0],
  },
  {
    column: "Joined Date",
    field: "joinedDate",
    width: 40,
    type: String,
    value: (row) => row[1],
  },
  {
    column: "Role",
    field: "role",
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Status",
    field: "status",
    type: String,
    value: (row) => row[3],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Last Active",
    field: "lastActive",
    width: 40,
    type: String,
    value: (row) => row[7],
  },
];
export const SHARES_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Email",
    field: "email",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Joined Date",
    field: "joinedDate",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Status",
    field: "status",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Recipients",
    field: "recipients",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Last Active",
    field: "lastActive",
    type: String,
    width: 40,
    value: (row) => row[7],
  },
];

export const TOP_USER_GROUPS_SCHEMA = [
  {
    column: "Group Name",
    field: "groupName",
    type: String,
    width: 80,
    value: (row) => row[0],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Avg View Time",
    field: "avgTime",
    type: Number,
    value: (row) => Number(row[2]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[3]),
  },
  {
    column: "Users",
    field: "users",
    type: Number,
    value: (row) => Number(row[4]),
  },
];
export const COLLECTIONS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created By",
    field: "createdBy",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Created On",
    field: "createdOn",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Last Updated",
    field: "lastUpdated",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[6]),
  },
];
export const ASSETS_SHARED_SCHEMA = [
  {
    column: "Asset Name",
    field: "assetName",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Author",
    field: "author",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[3]),
  },
  {
    column: "Avg View Time",
    field: "avgTime",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Downloads",
    field: "downloads",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[6]),
  },
];

export const SEARCH_QUERIES_SCHEMA = [
  {
    column: "Query",
    field: "query",
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Search Count",
    field: "searchCount",
    type: Number,
    value: (row) => Number(row[1]),
  },
];

export const SEARCH_TAGS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Asset Count",
    field: "assetCount",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Search Count",
    field: "searchCount",
    type: Number,
    value: (row) => Number(row[2]),
  },
];

export const CONTENT_DISCOVERY_MATRIX = [
  {
    column: "Asset Name",
    field: "name",
    type: String,
    width: 80,
    value: (row) => row[0],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Author",
    field: "author",
    width: 40,
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[3]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[5]),
  },
];

export const VIEWERS_SCHEMA = [
  {
    column: "Contact Name",
    field: "contactName",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Email",
    field: "email",
    width: 40,
    type: String,
    value: (row) => row[1],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  { column: "Company", field: "company", type: String, value: (row) => row[3] },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Reshares",
    field: "reshares",
    type: Number,
    value: (row) => Number(row[6]),
  },
];

export const TOP_ACCOUNTS_SCHEMA = [
  {
    column: "Account Name",
    field: "accountName",
    width: 40,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Contacts",
    field: "contacts",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[2]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[3]),
  },
  {
    column: "# of Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[4]),
  },
];

export const CAMPAIGNS_SCHEMA = [
  {
    column: "Campaign Name",
    field: "campaignName",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[2]),
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[3]),
  },
];

export const CONTENT_SHARED_SCHEMA = [
  {
    column: "Campaign Source",
    field: "campaignSource",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Avg View Time",
    field: "avgViewTime",
    type: Number,
    value: (row) => Number(row[2]),
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[3]),
  },
];

export const CONVERSATION_ACTIVITY_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Recipients",
    field: "recipients",
    type: Number,
    value: (row) => Number(row[2]),
  },
  {
    column: "Shared By",
    field: "sharedBy",
    type: String,
    value: (row) => row[3],
  },
  {
    column: "Shared On",
    field: "sharedOn",
    type: String,
    width: 40,
    value: (row) => row[4],
  },
  {
    column: "Shared Via",
    field: "sharedVia",
    type: String,
    value: (row) => row[5],
  },
  {
    column: "Open Rate",
    field: "openRate",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Click Rate",
    field: "clickRate",
    type: Number,
    value: (row) => Number(row[7]),
  },
  {
    column: "Time Spent",
    field: "timeSpent",
    type: Number,
    value: (row) => Number(row[8]),
  },
  {
    column: "Type",
    field: "type",
    type: String,
    value: (row) => row[9],
  },
];

export const COLLECTION_ACTIVITY_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created By",
    field: "createdBy",
    width: 40,
    type: String,
    value: (row) => row[1],
  },
  {
    column: "Created On",
    field: "createdOn",
    width: 40,
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Last Updated",
    field: "lastUpdated",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    value: (row) => Number(row[6]),
  },
];

export const CONTENT_LEADS_SCHEMA = [
  {
    column: "Content Used",
    field: "contentUsed",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Total Interactions",
    field: "totalInteractions",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Total Leads",
    field: "totalLeads",
    type: Number,
    value: (row) => Number(row[2]),
  },
];

export const CLOSED_DEALS_SCHEMA = [
  {
    column: "Content Used",
    field: "contentUsed",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Total Interactions",
    field: "totalInteractions",
    type: Number,
    width: 20,
    value: (row) => Number(row[1]),
  },
  {
    column: "Total Deals Closed",
    field: "totalDealsClosed",
    type: Number,
    width: 20,
    value: (row) => Number(row[2]),
  },
];

export const LEADS_DETAILS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Email",
    field: "email",
    type: String,
    value: (row) => row[1],
  },
  {
    column: "Account",
    field: "account",
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Date Added",
    field: "dateAdded",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Content Used",
    field: "contentUsed",
    type: String,
    value: (row) => row[4],
  },
  {
    column: "UTM Campaign Name",
    field: "utmCampaignName",
    type: String,
    value: (row) => row[5],
  },
  {
    column: "UTM Campaign Source",
    field: "utmSource",
    type: String,
    value: (row) => row[6],
  },
  {
    column: "UTM Campaign Medium",
    field: "utmMedium",
    type: String,
    value: (row) => row[7],
  },
  {
    column: "UTM Campaign Term",
    field: "utmTerm",
    type: String,
    value: (row) => row[8],
  },
  {
    column: "UTM Campaign Content",
    field: "utmContent",
    type: String,
    value: (row) => row[9],
  },


];

export const DEALS_DETAILS_SCHEMA = [
  {
    column: "Deal",
    field: "deal",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Deal Value",
    field: "dealValue",
    type: Number,
    value: (row) => Number(row[1]),
  },
  {
    column: "Deal Stage",
    field: "dealStage",
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
];

export const ADVOCACY_TOP_SHARED_ASSETS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    type: String,
    width: 50,
    value: (row) => row[0],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Author",
    field: "author",
    width: 50,
    type: String,
    value: (row) => row[2],
  },
  {
    column: "File Type",
    field: "fileType",
    type: String,
    value: (row) => row[3],
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    width: 20,
    value: (row) => Number(row[4]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    width: 20,
    value: (row) => Number(row[5]),
  },
  {
    column: "Downloads",
    field: "downloads",
    type: Number,
    width: 20,
    value: (row) => Number(row[6]),
  },
  {
    column: "Comments",
    field: "comments",
    type: Number,
    width: 20,
    value: (row) => Number(row[7]),
  },
  {
    column: "Reactions",
    field: "reactions",
    type: Number,
    width: 20,
    value: (row) => Number(row[8]),
  },
  {
    column: "Average Time Spent",
    field: "avgTime",
    type: Number,
    width: 20,
    value: (row) => Number(row[9]),
  },
  {
    column: "Total Time Spent",
    field: "totalTimeSpent",
    type: Number,
    width: 20,
    value: (row) => Number(Number(row[10]).toFixed(2)),
  },
  {
    column: "Recipients",
    field: "recipients",
    type: Number,
    width: 20,
    value: (row) => Number(row[11]),
  },
]

export const ADVOCACY_TOP_ENGAGED_ASSETS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    type: String,
    width: 50,
    value: (row) => row[0],
  },
  {
    column: "Created Date",
    field: "createdDate",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "File Type",
    field: "fileType",
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Author",
    field: "author",
    width: 50,
    type: String,
    value: (row) => row[3],
  },
  {
    column: "Comments",
    field: "comments",
    type: Number,
    width: 20,
    value: (row) => Number(row[4]),
  },
  {
    column: "Recipients",
    field: "recipients",
    type: Number,
    width: 20,
    value: (row) => Number(row[5]),
  },
  {
    column: "Reactions",
    field: "reactions",
    type: Number,
    width: 20,
    value: (row) => Number(row[6]),
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    width: 20,
    value: (row) => Number(row[7]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    width: 20,
    value: (row) => Number(row[8]),
  },
  {
    column: "Average Time Spent",
    field: "avgTime",
    type: Number,
    width: 20,
    value: (row) => Number(row[9]),
  },
  {
    column: "Total Time Spent",
    field: "totalTime",
    type: Number,
    width: 20,
    value: (row) => Number(Number(row[10]).toFixed(2)),
  },
]

export const ADVOCACY_TOP_SHARERS_SCHEMA = [
  {
    column: "Created By",
    field: "createdBy",
    type: String,
    width: 50,
    value: (row) => row[0],
  },
  {
    column: "Email",
    field: "email",
    type: String,
    width: 50,
    value: (row) => row[1],
  },
  {
    column: "Created On",
    field: "createdOn",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    width: 20,
    value: (row) => Number(row[3]),
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    width: 20,
    value: (row) => Number(row[4]),
  },
  {
    column: "Recipients",
    field: "recipients",
    type: Number,
    width: 20,
    value: (row) => Number(row[5]),
  },
]

// name, shares, users count, assets
export const ADVOCACY_TOP_SHARED_USER_GROUPS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    type: String,
    width: 50,
    value: (row) => row[0],
  },
  {
    column: "Shares",
    field: "shares",
    type: Number,
    width: 20,
    value: (row) => Number(row[1]),
  },
  {
    column: "Users Count",
    field: "usersCount",
    type: Number,
    width: 20,
    value: (row) => Number(row[2]),
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    width: 20,
    value: (row) => Number(row[3]),
  },
]

export const TODAY = "today";
export const YESTERDAY = "yesterday";
export const SEVEN_DAYS = "7Days";
export const FOURTEEN_DAYS = "14Days";
export const WEEK_TO_DATE = "WTD";
export const MONTH_TO_DATE = "MTD";
export const THIRTY_DAYS = "30Days";
export const NINETY_DAYS = "90Days";
export const ALL_TIME = "ALL_TIME";
export const CUSTOM = "custom";

export const DATE_RANGES = [
  {
    label: TODAY,
    value: "Today",
  },
  {
    label: YESTERDAY,
    value: "Yesterday",
  },
  {
    label: SEVEN_DAYS,
    value: "7 Days",
  },
  {
    label: FOURTEEN_DAYS,
    value: "14 Days",
  },
  {
    label: WEEK_TO_DATE,
    value: "Week to Date",
  },
  {
    label: MONTH_TO_DATE,
    value: "Month to Date",
  },
  {
    label: THIRTY_DAYS,
    value: "30 Days",
  },
  {
    label: NINETY_DAYS,
    value: "90 Days",
  },
  {
    label: ALL_TIME,
    value: "All Time",
  },
];

export const REPORTS_FILTERS = [
  { name: "Stream", value: STREAM, filter_type: "entity_filter" },
  { name: "Collection", value: COLLECTION, filter_type: "entity_filter" },
  {name: "Deal Room", value: DEAL_ROOM , filter_type: "entity_filter" },
  { name: "Asset", value: ASSET, filter_type: "entity_filter" },
  { name: "User", value: USER, filter_type: "entity_filter" },
  { name: "User Group", value: USER_GROUP, filter_type: "entity_filter" },
  { name: "Contact", value: CONTACT, filter_type: "entity_filter" },
  { name: "Company", value: COMPANY, filter_type: "entity_filter" },
];

export const CONDITIONS = [{
  type: USER,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }, {
    key: 'has_role',
    text: "has_role",
    unary: false 
  }]
}, {
  type: STREAM,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }]
}, {
  type: COLLECTION,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }]
}, {
  type: ASSET,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }]
}, {
  type: SHARE,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }]
}, {
  type: USER_GROUP,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }]
}, {
  type: CONTACT,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }, {
    key: 'is_internal',
    text: "is_internal",
    unary: true
  }, {
    key: 'is_not_internal',
    text: "is_not_internal",
    unary: true
  }]
}, {
  type: COMPANY,
  options: [{
    key: 'is',
    text: "is",
    unary: false
  }, {
    key: 'is_not',
    text: "is_not",
    unary: false
  }, {
    key: 'is_internal',
    text: "is_internal",
    unary: true
  }, {
    key: 'is_not_internal',
    text: "is_not_internal",
    unary: true
  },{
    type: DEAL_ROOM,
    options: [{
      key: 'is',
      text: "is",
      unary: false
    }, {
      key: 'is_not',
      text: "is_not",
      unary: false
    }]
  },]
}
]

export const DEAL_ROOMS_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 80,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created By",
    field: "createdBy",
    type: String,
    width: 40,
    value: (row) => row[1],
  },
  {
    column: "Created On",
    field: "createdOn",
    type: String,
    width: 40,
    value: (row) => row[2],
  },
  {
    column: "Last Updated",
    field: "lastUpdated",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Stakeholders",
    field: "stakeholders",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Total Interactions",
    field: "totalInteractions",
    type: Number,
    value: (row) => Number(row[7]),
  },
];

export const DEAL_ROOM_ACTIVITY_SCHEMA = [
  {
    column: "Name",
    field: "name",
    width: 50,
    type: String,
    value: (row) => row[0],
  },
  {
    column: "Created By",
    field: "createdBy",
    width: 40,
    type: String,
    value: (row) => row[1],
  },
  {
    column: "Created On",
    field: "createdOn",
    width: 40,
    type: String,
    value: (row) => row[2],
  },
  {
    column: "Last Updated",
    field: "lastUpdated",
    type: String,
    width: 40,
    value: (row) => row[3],
  },
  {
    column: "Assets",
    field: "assets",
    type: Number,
    value: (row) => Number(row[4]),
  },
  {
    column: "Views",
    field: "views",
    type: Number,
    value: (row) => Number(row[5]),
  },
  {
    column: "Stakeholders",
    field: "stakeholders",
    type: Number,
    value: (row) => Number(row[6]),
  },
  {
    column: "Total Interactions",
    field: "totalInteractions",
    type: Number,
    value: (row) => Number(row[7]),
  }
];

export const reportsFilterMapping = {
  [ReportTabs.discovery]:{
    [DiscoveryTables.assetViews]: [STREAM, ASSET, COLLECTION, USER, USER_GROUP],
    [DiscoveryTables.assets]: [STREAM, USER, USER_GROUP],
    [DiscoveryTables.discoveryMatrix]: [STREAM],
    [DiscoveryTables.collectionActivity]: [ASSET, USER, USER_GROUP],
    [DiscoveryTables.conversationActivity]: [ASSET, COLLECTION, USER, USER_GROUP],
    [DiscoveryTables.popularTeam]: [STREAM, ASSET, USER, USER_GROUP],
    [DiscoveryTables.topUsers]: [STREAM, ASSET, USER, USER_GROUP],
    [DiscoveryTables.topSharers]: [ ASSET, USER, USER_GROUP],
    [DiscoveryTables.topUserGroups]: [STREAM, ASSET, USER, USER_GROUP],
    [DiscoveryTables.collectionsCreated]: [ASSET, USER, USER_GROUP],
    [DiscoveryTables.collectionsShared]: [ASSET, COLLECTION, USER, USER_GROUP],
    [DiscoveryTables.dealRoomsCreated]: [USER, USER_GROUP, DEAL_ROOM],
    [DiscoveryTables.dealRoomsShared]: [USER, USER_GROUP, DEAL_ROOM],
    [DiscoveryTables.sharedAssets]: [ ASSET, USER, USER_GROUP],
    [DiscoveryTables.usedTags]: [STREAM, USER, USER_GROUP],
  },
  [ReportTabs.engagement]: {
    [EngagementTables.avgAttentionTime]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.uniqueViewers]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.shares]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.assetViews]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.popularViewers]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.topViewers]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.topAccounts]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.campaignPerforming]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.contentShared]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.conversationActivity]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.collectionActivity]: [ASSET, COLLECTION, USER, USER_GROUP, CONTACT, COMPANY],
    [EngagementTables.dealRoomActivity]: [ASSET, USER, USER_GROUP, DEAL_ROOM],
  },
  [ReportTabs.performance]: {
    [PerformanceTables.interactionContent]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.leads]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.deals]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.dealValue]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.closedDeals]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.closedDealValue]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.topGenerateLeads]: [COLLECTION, USER, USER_GROUP],
    [PerformanceTables.topClosedDeals]: [COLLECTION, USER, USER_GROUP]
  },
  [ReportTabs.advocacy]: {
    [AdvocacyTables.timeSpent]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.views]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.shares]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.topSharers]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.topSharedAssets]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.topEngagedAssets]: [ASSET, USER, USER_GROUP],
    [AdvocacyTables.topUserGroups]: [ASSET, USER, USER_GROUP],
  }
}

